export default __webpack_public_path__ + "static/media/eftLogo.6127a572.svg";